/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The EventsControllerDtoEventFreeNftDetailResponse model module.
 * @module model/EventsControllerDtoEventFreeNftDetailResponse
 * @version 1.0
 */
class EventsControllerDtoEventFreeNftDetailResponse {
    /**
     * Constructs a new <code>EventsControllerDtoEventFreeNftDetailResponse</code>.
     * @alias module:model/EventsControllerDtoEventFreeNftDetailResponse
     */
    constructor() { 
        
        EventsControllerDtoEventFreeNftDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventFreeNftDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventFreeNftDetailResponse} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventFreeNftDetailResponse} The populated <code>EventsControllerDtoEventFreeNftDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventFreeNftDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('freenftNo')) {
                obj['freenftNo'] = ApiClient.convertToType(data['freenftNo'], 'Number');
            }
            if (data.hasOwnProperty('mintingCode')) {
                obj['mintingCode'] = ApiClient.convertToType(data['mintingCode'], 'String');
            }
            if (data.hasOwnProperty('issuedCount')) {
                obj['issuedCount'] = ApiClient.convertToType(data['issuedCount'], 'Number');
            }
            if (data.hasOwnProperty('usedCount')) {
                obj['usedCount'] = ApiClient.convertToType(data['usedCount'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventFreeNftDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventFreeNftDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['mintingCode'] && !(typeof data['mintingCode'] === 'string' || data['mintingCode'] instanceof String)) {
            throw new Error("Expected the field `mintingCode` to be a primitive type in the JSON string but got " + data['mintingCode']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} freenftNo
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['freenftNo'] = undefined;

/**
 * @member {String} mintingCode
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['mintingCode'] = undefined;

/**
 * @member {Number} issuedCount
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['issuedCount'] = undefined;

/**
 * @member {Number} usedCount
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['usedCount'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventFreeNftDetailResponse.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventFreeNftDetailResponse;

